import React from 'react';

export default function AuthTransitionPage({ error = null }) {
    return (
        <main
            aria-live="polite"
            style={{
                minHeight: '100vh',
                display: 'grid',
                placeItems: 'center',
                padding: '2rem',
                textAlign: 'center',
                boxSizing: 'border-box',
                fontFamily: 'sans-serif',
            }}
        >
            <div>
                <h1>{error ? 'Sign-in could not be completed' : 'Completing sign-in…'}</h1>
                {error ? (
                    <>
                        <p>{error.message || 'The identity provider returned an unexpected error.'}</p>
                        <button type="button" onClick={() => window.location.replace('/')}>
                            Return to Online Help
                        </button>
                    </>
                ) : (
                    <p>Please wait while your session is restored.</p>
                )}
            </div>
        </main>
    );
}

